import React, { forwardRef } from "react";
import { useAtom } from "jotai";
import { avatarAtomFamily } from "../../jotai/atoms";
import { setRecordAvatar } from "../../jotai/atomUpdater";
import { avatars } from "../../utils/data";
import {
  ModalV2,
  ModalV2BackButton,
  ModalV2Body,
  ModalV2Header,
} from "../../components/modals/ModalV2";
import { useTranslation } from "react-i18next";

interface AvatarListModalProps {
  recordId: string | null;
}

export const AvatarListModal = forwardRef<HTMLDialogElement, AvatarListModalProps>(
  function AvatarListModal({ recordId }, ref) {
    const { t } = useTranslation();
    const [currAvatarId] = useAtom(avatarAtomFamily(recordId ?? ""));

    const selectAvatar = async (avatarId: number) => {
      if (!recordId) return;
      const updateValue = currAvatarId === avatarId ? null : avatarId;
      await setRecordAvatar(recordId, updateValue);
    };

    return (
      <ModalV2 modalBoxClassName="bg-base-100 max-w-3xl" ref={ref}>
        <div>
          <ModalV2Header className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2">
              <ModalV2BackButton />
              <p className="font-semibold text-xl">Select Avatar</p>
            </div>
          </ModalV2Header>
        </div>
        <ModalV2Body className="bg-base-100 pt-2">
          <div className="grid max-md:grid-cols-3 grid-cols-6 gap-4 p-4">
            {Array.from(avatars.entries()).map(([avatarId, src]) => (
              <div
                key={avatarId}
                className={`mx-auto cursor-pointer rounded-full transition-colors ${
                  currAvatarId === avatarId
                    ? "ring-4 ring-primary ring-offset-2 border-primary"
                    : ""
                }`}
                onClick={() => selectAvatar(avatarId)}
              >
                <div
                  className="w-16 h-16 bg-cover"
                  style={{ backgroundImage: `url(${src})` }}
                ></div>
              </div>
            ))}
          </div>
        </ModalV2Body>
      </ModalV2>
    );
  }
);

export default AvatarListModal;
